import { Grid, Typography, WithStyles, withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MyPATDialog } from '../../../common';

import { courseStyles } from "../../styles";

interface Props extends WithStyles<typeof courseStyles> {
  onClose: () => void;
  classes: any;
  open: boolean;
  history: any;
}

interface State {}

interface CourseOption {
  icon: string;
  title: string;
  description: string;
  linkIcon: string;
}
class CreateCoursePopup extends Component<Props, State> {
  renderCourseTypeOption = (courseOption: CourseOption) => {
    const { icon, title, description, linkIcon } = courseOption;
    const { classes } = this.props;
    return (
      <Grid container spacing={8} alignItems="center" className={[classes.ptb15, classes.pointer].join(' ')}>
        <Grid item xs={2} className={classes.popupIcon}>
          <img src={icon} alt={title} />
        </Grid>
        <Grid item xs={9}>
          <Grid container onClick={() => this.redirectUser(title)}>
            <Grid item xs={12}>
              {/* add color as per title colorPrimary, colorYellow, colorRed */}
              <span className={title === 'Standard Course' ? [classes.colorPrimary,classes.title].join(' '):
                               title === 'Test Series' ? [classes.colorYellow,classes.title].join(' '):
                               title === 'Combo Course' ? [classes.colorRed,classes.title].join(' '): ''}>{title}</span>
            </Grid>
            <Grid item xs={12}>
              <span className={classes.description}>{description}</span>
            </Grid>
          </Grid>
        </Grid>
        {/* onClick={() => this.redirectUser(title)} */}
        <Grid item xs={1} className={classes.txtCenter} onClick={() => this.redirectUser(title)}>
          <img src={linkIcon} alt={title}/>
        </Grid>
      </Grid>
    );
  };

  redirectUser(title: string){
      switch(title){
          case 'Standard Course':
              this.props.history.push('/course-Management/create-standard-course');
              break;
          case 'Test Series':
              this.props.history.push('/course-Management/create-testSeries');
              break;
          case 'Combo Course':
              this.props.history.push('/course-Management/create-combo-course');
              break;
          default:
      }
  }

  render() {
    const { onClose, classes, open } = this.props;
    //console.log(close);

    return (
      <MyPATDialog
        dialogOpen={open}
        dialogHasActions={false}
        onDialogClose={onClose}
        dialogHeading={
          <>
            <Typography className={classes.font24}>Create Course</Typography>
          </>
        }
        isAlignCenter={false}
        variantHeader="leftHeader"
        customButtonVariant="withoutBorderCloseIcon"
        isCustomBackground={false} //Check
        isborderDialogAction={false}
        // otherDialogProps={{
        //     fullWidth: false,
        //   }}
        // customDialogActions={}
      >
        <Grid container justify="flex-start" alignItems="center" className={classes.minus15T}>
          <Grid item xs={12} className={classes.borderB}>
            {this.renderCourseTypeOption({
              icon: '/assets/svg/standardCourse.svg',
              title: 'Standard Course',
              description: 'Standard courses are created with a proper course plan which can be bifurcated into phases and weekly plan. You can create a version for such course.',
              linkIcon: '/assets/svg/myLibrary/arrowRightGray.svg',
            })}
          </Grid>
          <Grid item xs={12} className={classes.borderB}>
             {this.renderCourseTypeOption({
              icon: '/assets/svg/testSeries.svg',
              title: 'Test Series',
              description: 'Test Series includes only scheduled tests and are arranged according to respective schedule. This type of course does not include any course plan.',
              linkIcon: '/assets/svg/myLibrary/arrowRightGray.svg',
            })}
          </Grid>
          <Grid item xs={12}>
             {this.renderCourseTypeOption({
              icon: '/assets/svg/comboSeries.svg',
              title: 'Combo Course',
              description: 'Combo course is defined with a course plan from multiple goals/ multiple standard courses. You can create a version for such course', // Check with product for description
              linkIcon: '/assets/svg/myLibrary/arrowRightGray.svg',
            })}
          </Grid>
        </Grid>
      </MyPATDialog>
    );
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(CreateCoursePopup)));
